import React, {useState} from "react";
import { Link, withRouter } from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import { COLLAPSED_DRAWER, FIXED_DRAWER } from '../../constants/ActionTypes';
import SearchBox from "../../components/SearchBox";
import AppNotification from "../../components/AppNotification";
import LicenseNotice from "../../components/LicenseNotice";
import { switchLanguage, switchCurrency, toggleCollapsedNav } from "../../actions";
import LanguageSwitcher from "../../components/LanguageSwitcher";
import CurrencySwitcher from "../../components/CurrencySwitcher";
import { translator } from '../../utils/Translator';
import Logo from '../../assets/images/logo.png';

const Header =(props)=> {
  const dispatch = useDispatch();

  const { drawerType, languageSelected, currencySelected } = useSelector(({settings}) => settings);
  const { translate } = useSelector(({i18n}) => i18n);

  const [langSwitcher,setLangSwitcher]=useState(false);
  const [currSwitcher, setCurrSwitcher] = useState(false);
  const [appNotification,setAppNotification]=useState(false);
  const [searchBox,setSearchBox]=useState(false);
  const [searchText,setSearchText]=useState('');

  const onAppNotificationSelect = () => {
    setAppNotification(!appNotification)
  };
  
  const onLangSwitcherSelect = (event) => {
    setLangSwitcher(!langSwitcher);
  };

  const onCurrSwitcherSelect = () => {
    setCurrSwitcher(!currSwitcher);
  }

  const onSearchBoxSelect = () => {
    setSearchBox(!searchBox)
  };
  
  const handleRequestClose = () => {
    setSearchBox(false);
    setLangSwitcher(false);
    setCurrSwitcher(false);
    setSearchBox(false);
  };

  const onToggleCollapsedNav = (e) => {
    const val = !props.navCollapsed;
    dispatch(toggleCollapsedNav(val));
  };

  const updateSearchText =(evt)=> {
    setSearchText(evt.target.value);
  };

  const onSwitchLanguage = (lang) => {
    dispatch(switchLanguage(lang));
    // Reload the page to force Google Maps to use the new language
    setTimeout(() => {
      window.location.reload();
    }, 100);
  };

  const onSwitchCurrency = (curr) => {
    dispatch(switchCurrency(curr))
  }

  const drawerStyle = drawerType.includes(FIXED_DRAWER) ? "d-block d-xl-none" : drawerType.includes(COLLAPSED_DRAWER) ? "d-block" : "d-none";

  return (
    <AppBar className="app-main-header">
      <Toolbar className="app-toolbar" disableGutters={false}>
        <IconButton className={`jr-menu-icon mr-3 ${drawerStyle}`} aria-label="Menu" onClick={onToggleCollapsedNav}>
          <span className="menu-icon"/>
        </IconButton>

        <Link className="app-logo mr-2 d-none d-sm-block" to="/">
          <img src={ Logo } alt="Logo" title="Logo"/>
        </Link>

        { process.env.REACT_APP_ENV ? process.env.REACT_APP_ENV : "" }
        

        {/* <SearchBox styleName="d-none d-lg-block" placeholder="" onChange={updateSearchText} value={searchText}/> */}

        <ul className="header-notifications list-inline ml-auto">
          <li className="d-inline-block d-lg-none list-inline-item">
              <Dropdown className="quick-menu nav-searchbox"
                isOpen={searchBox}
                toggle={onSearchBoxSelect}>

                <DropdownToggle className="d-inline-block" tag="span" data-toggle="dropdown">
                  <IconButton className="icon-btn">
                    <i className="zmdi zmdi-search zmdi-hc-fw"/>
                  </IconButton>
                </DropdownToggle>
                <DropdownMenu right className="p-0">
                  <SearchBox styleName="search-dropdown" placeholder=""
                    onChange={updateSearchText}
                    value={searchText}/>
                </DropdownMenu>
              </Dropdown>
          </li>
          {/* แจ้งจำนวนวันก่อน License หมดอายุ — render <li> เองเฉพาะช่วงแจ้งเตือน */}
          <LicenseNotice />
          <li className="list-inline-item">
            <Dropdown
              className="quick-menu"
              isOpen={langSwitcher}
              toggle={onLangSwitcherSelect}>

              <DropdownToggle
                className="d-inline-block"
                tag="span"
                data-toggle="dropdown">
                  <IconButton className="icon-btn">
                    <img src={languageSelected.icon} 
                      alt={languageSelected.name} 
                      title={languageSelected.name}
                      style={{width: 24}}/>
                  </IconButton>
              </DropdownToggle>

              <DropdownMenu right className="w-50">
                <LanguageSwitcher switchLanguage={onSwitchLanguage} handleRequestClose={handleRequestClose}/>
              </DropdownMenu>
            </Dropdown>
          </li>
          <li className="list-inline-item">
            <Dropdown
              className="quick-menu"
              isOpen={currSwitcher}
              toggle={onCurrSwitcherSelect}>

              <DropdownToggle
                className="d-inline-block"
                tag="span"
                data-toggle="dropdown">
                  <IconButton className="icon-btn">
                    <label className="text-white jr-fs-md" style={{paddingTop: 6, paddingBottom: 6}}>{currencySelected.code}</label>
                  </IconButton>
              </DropdownToggle>

              <DropdownMenu right className="w-50">
                <CurrencySwitcher switchCurrency={onSwitchCurrency} handleRequestClose={handleRequestClose}/>
              </DropdownMenu>
            </Dropdown>
          </li>
            <li className="list-inline-item app-tour">
                <Dropdown
                    className="quick-menu"
                    isOpen={appNotification}
                    toggle={onAppNotificationSelect}>

                    <DropdownToggle
                    className="d-inline-block"
                    tag="span"
                    data-toggle="dropdown">
                    <IconButton className="icon-btn">
                        <i className="zmdi zmdi-notifications-none icon-alert animated infinite wobble"/>
                    </IconButton>
                    </DropdownToggle>

                    <DropdownMenu right>
                        <div className={`jr-card-header d-flex align-items-start align-items-center`}>
                            <div className="mr-auto">
                                <h3 className="card-heading">Notification</h3>
                            </div>

                            <IconButton className="icon-btn text-dark" >
                                <i className="zmdi zmdi-chevron-down"/>
                            </IconButton>
                        </div>
                        <AppNotification open={appNotification} />
                    </DropdownMenu>
                </Dropdown>
            </li>
          </ul>

          <div className="ellipse-shape"/>
        </Toolbar>
    </AppBar>
  );
};

export default withRouter(Header);